import './footer-style.scss';

const Footer = () => {
  return (
    <footer id="app-footer" className="footer">
      <div className="container-fluid footer-container">
        <div className="footer-row grid grid-cols-1 sm:grid-cols-3">
          <div className="footer-col-left col-span-1 sm:col-span-1">
            <span className="footer-copyright">
              Copyright © {new Date().getFullYear()} Qluu
            </span>
          </div>
          <div className="footer-col-center col-span-1 sm:col-span-1">
            <a href="https://qluu.ai/terms" className="footer-link">
              Terms of Service
            </a>
          </div>
          <div className="footer-col-right col-span-1 sm:col-span-1">
            <a
              href="mailto:contactus@qluu.net"
              className="footer-email footer-link"
            >
              contactus@qluu.net
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export { Footer };
